import { Grid, InputLabel, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { XCircle } from '../../icons/x-circle';
import { rowStyle, styleTalentDetails } from './style';
import { TALENTS_BASIC_INPUTS_NAME } from './Constants';

type PropsBasicPhoneRow = {
  label: string,
  value: string,
  error: string,
  // onDeleteClick: () => void,
  onValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onDeletePhone: (e: React.MouseEvent) => void,
  isShowDeleteButton: boolean,
  placeholder: string,
};

export const BasicPhoneRow = (
  {
    label,
    value,
    // onDeleteClick,
    onValueChange,
    onDeletePhone,
    error,
    isShowDeleteButton,
    placeholder,
  }:PropsBasicPhoneRow)
  :JSX.Element => {
  return (
    <Grid sx={ styleTalentDetails.cardContent.form.box }
      style={
        {
          backgroundColor: error ?
            styleTalentDetails.cardContent.form.error.backgroundColor : 'unset',
        }
      }
      container
    >
      <Grid item xs={ styleTalentDetails.cardContent.form.boxLabel.xs }>
        <InputLabel
          htmlFor={ TALENTS_BASIC_INPUTS_NAME.PHONE }
          style={ styleTalentDetails.cardContent.form.InputLabel }
        >
          { label }
        </InputLabel>
      </Grid>
      <Grid item xs={ styleTalentDetails.cardContent.form.boxInput.xs }>
        <TextField
          variant="standard"
          name={ TALENTS_BASIC_INPUTS_NAME.PHONE }
          fullWidth
          value={ value }
          onChange={ onValueChange }
          placeholder={ placeholder }
          InputProps={ {
            style: styleTalentDetails.cardContent.form.TextField,
            disableUnderline: true,
          } }
        />
      </Grid>
      <Grid item
        xs={ styleTalentDetails.cardContent.form.boxIcon.xs }
        textAlign={ styleTalentDetails.cardContent.form.boxIcon.textAlign }
      >
        <Box sx={ styleTalentDetails.cardContent.form.boxIcon.box  }>
          {isShowDeleteButton && (
            <Box onClick={ onDeletePhone } style={ rowStyle.iconWrapper.style }>
              <XCircle style={ rowStyle.xCircleIcon.style } />
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
